import { type RouteObject } from "react-router-dom";

import { AUTH_ROLES } from "api/common/types/auth.types";
import EarReviewsTable from "features/memberPortal/EAR/components/EarReviewsTable/EarReviewsTable";
import EarManager from "features/memberPortal/EAR/Ear.screen";
import EarDetails from "features/memberPortal/EAR/EarDetails/EarDetails.screen";
import AuthenticatedRoute from "routing/AuthenticatedRoute";

const { NIAP, VALIDATOR, SME } = AUTH_ROLES;

const earRoutes: RouteObject[] = [
  {
    path: "ear-reviews",
    element: <EarManager />,
    children: [
      {
        element: <AuthenticatedRoute allowedRoles={[VALIDATOR, NIAP, SME]} />,
        children: [
          {
            index: true,
            element: (
              // @ts-ignore - need to properly type underlying table
              <EarReviewsTable filter={true} showAddEarButton={true} />
            ),
          },
        ],
      },
      { path: "details/:id", element: <EarDetails /> },
    ],
  },
];

export default earRoutes;
